"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.executionTimerPlugin = void 0;
var tslib_1 = require("tslib");
var executionTimerPlugin = function (context, next) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var startTime, chainResult;
    return tslib_1.__generator(this, function (_a) {
        console.log("#executionTimerPlugin() measuring start and stop (duration) of overall composition of ".concat(context.hookName));
        startTime = Date.now ? Date.now() : new Date().getTime();
        chainResult = next(context);
        chainResult.then(function (result) {
            console.log('#executionTimerPlugin.nextHandler()');
            var endTime = Date.now ? Date.now() : new Date().getTime();
            var forwardEndTime = result && result.forwardEndTime;
            console.log("\n    ***********************************************************\n    ** plugin chain execution times for ".concat(context.hookName, ": \n    ** - total: ").concat(endTime - startTime, "ms\n    ** - forward: ").concat(typeof forwardEndTime === 'number' ? forwardEndTime - startTime : 0, "ms\n    ** - backward: ").concat(typeof forwardEndTime === 'number' ? endTime - forwardEndTime : 0, "ms\n    ***********************************************************\n    "));
        });
        return [2 /*return*/, chainResult];
    });
}); };
exports.executionTimerPlugin = executionTimerPlugin;
//# sourceMappingURL=execution-timer-plugin.js.map